import React, { useEffect, useState } from "react";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import { getValue, setValue } from "@utils/lodash";
import { useNavigate } from "react-router-dom";
import NavigationBar from "@components/NotificationBar/index";
import DeleteModal from "@_common/deleteModal";
import { toast } from "react-toastify";
import PaginationPage from "@components/pagination/pagination";
import SearchHeader from "@components/common/SearchHeader";
import { adminDeleteSpecificOrganization } from "@services/client-list.service";
import Notfound from "@components/Not-Found";
import moment from "moment";
import Loader from "@components/common/Loader";
// import DatePicker from "react-date-picker";
import FilterForm from "@components/common/Compliance-AddFilter/FilterForm";
import {
  adminGetCountriesListManagement,
  adminGetListManagementGroupCode,
  adminGetStatesListManagement,
  getSmartFilterCategoryOfLawList,
  getSmartFilterLegislationList,
  getSmartFilterLegislationRuleList,
} from "@services/list-management.service";
import {
  adminGetCheckpoint,
  GetCheckpointPEComplianceTask,
  UpdateBulkStatusCheckpointPEComplianceTask,
} from "@services/checkpoint.service";
import { useParams } from "react-router-dom";
import { formatText } from "@_common/format-text";
import {
  Button,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import {
  clientGetFunction,
  clientGetLocation,
} from "@services/location.service";
import { QueryRequestHelper } from "@_common/query-request-helper";
import CalenderDropdown from "@_common/CalenderDropdown";
import ScrollableReactTable from "@components/ScrollableDatatable";
import {
  exportShowCauseNotice,
  getShowCauseNoticeDetails,
  getShowCauseNotices,
  getShowCauseNoticesEntityMapping,
} from "@services/causenotice.service";
import {
  convertCurrentDate,
  convertDate,
  convertDateAsString,
} from "@_common/date-helpers";
import DashboardUserFilterForm from "@components/common/DashboardFilterForm/user-filter-form";
import {
  getEntityGroups,
  getUserEntityGroupsItems,
} from "@services/entity-mapping.service";
import { handleDownloadOnClick } from "@_common/downloadfile";
import NoAccessPage from "@components/common/NoAccess";
import DatePicker from "react-datepicker";
import ReportsNotfound from "@components/Page-Not-Found/reports-not-found";
import MoreReportSvgComponent from "../../assets/svg-components/left-menu/more-report";
import RightMenuHeaders from "@components/common/RightMenuHeaders";
import { countKeysWithValues } from "@_common/text-helpers";
import ModuleFilter from "@components/common/ModuleFilter";

interface IShowCauseNoticeProps {}

const ShowCauseNotice: React.FunctionComponent<IShowCauseNoticeProps> = (
  props: any
) => {
  let navigate = useNavigate();
  let mianParams = useParams();


  const urlParamsFun = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let request = QueryRequestHelper({ ...params });
    return request;
  };

  const mainQueryRequest = urlParamsFun();

  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */

  const [isLoading, setIsLoading] = React.useState(true);
  const [list, setList] = React.useState<[]>([]);
  const [isFilterVisible, setFilterVisibility] = React.useState(false);
  const [complianceTypeList, setComplianceTypeList] = useState([]);
  const [filterList] = useState([
    { value: "OPEN", label: "Open" },
    { value: "REPLY_SENT", label: "Reply Sent" },
    { value: "CLOSED", label: "Close" },
  ]);
  const [filterIsOpen, setFilterIsOpen] = useState(false);
  const handleFilter = () => {
    setFilterIsOpen(!filterIsOpen);
  };

  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    // getCountriesList();
    // getDataCompliance();
    // getDropdownInfo();

    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
      getHeaderList(paramsObj, 0);
      getData(paramsObj);
      setDate(new Date());

      let dates = params.date ? new Date(params.date) : new Date();
      var from_date = new Date(dates.getFullYear(), dates.getMonth(), 1);
      var to_date = new Date(dates.getFullYear(), dates.getMonth() + 1, 0);
      setFirstDay(from_date);
      setLastDay(to_date);
    }
  }, [props.permissionAPITriggered]);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      if (params.page_no) {
        setPage_no(parseInt(params.page_no));
      }
      if (params.search_text) {
        setSearchInput(params.search_text);
        setShowSearchTextbox(true);
      }
      if (params.limit) {
        setLimit(parseInt(params.limit));
      }
      if (params.date) {
        setDate(new Date(params.date));
      } else {
        setDate(new Date());
      }

      let paramObj: any = {};
      //finding only levels params if it presented in URL
      for (let i = 1; i < 11; i++) {
        if (getValue(params, `level${i}`, "")) {
          paramObj[`level${i}`] = getValue(params, `level${i}`, "");
        }
      }
      getData(paramObj);

      if (Object.keys(paramObj).length > 0) {
        setFilterVisibility(true);
      }
      if (params.from_date && params.to_date) {
        // setDate(new Date(params.date));
        var from_date = new Date(params.from_date);
        var to_date = new Date(params.to_date);
        setFirstDay(from_date);
        setLastDay(to_date);
      }
      setParamsObj(paramObj);
      getHeaderList(paramObj, 0);
    }
  }, [window.location.href, props.permissionAPITriggered]);

  /* -------------------------------------------------------------------------- */
  /*                              Date Routes                                   */
  /* -------------------------------------------------------------------------- */
  const [from_date, setFirstDay] = React.useState(new Date());
  const [to_date, setLastDay] = React.useState(new Date());
  const handleDate = (date: any) => {
    setFirstDay(date[0]);
    setLastDay(date[1]);
  };
  const handleSubmitDate = () => {
    let first = convertDate(from_date);
    let last = convertDate(to_date);
    if (first && last && first !== "Invalid date" && last !== "Invalid date") {
      let payload: any = {
        from_date: first,
        to_date: last,
      };
      if (payload.from_date && payload.to_date) {
        let queryRequest = QueryRequestHelper(payload);
        navigate(`${window.location.pathname}?${queryRequest}`);
      } else {
        toast.error("Start Date and End Date Required");
      }
    } else {
      toast.error("Please select date");
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */

  const getDataCompliance = async () => {
    try {
      let resp = await adminGetListManagementGroupCode("compliance-type");
      if (resp) {
        let list =
          getValue(resp, `data.listItems.length`, 0) > 0
            ? getValue(resp, `data.listItems`, []).filter((item: object) =>
                getValue(item, `is_active`, "")
              )
            : [];
        setComplianceTypeList(list);
      }
    } catch (error) {}
  };
  const getData = async (paramsObj: object) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    let dates = params.date ? new Date(params.date) : new Date();
    var from_date = params.from_date
      ? params.from_date
      : new Date(dates.getFullYear(), dates.getMonth(), 1);
    var to_date = params.to_date
      ? params.to_date
      : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);

    let payload: any = {
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      from_date: getValue(params, `from_date`, "")
        ? getValue(params, `from_date`, "")
        : convertDate(from_date),
      to_date: getValue(params, `to_date`, "")
        ? getValue(params, `to_date`, "")
        : convertDate(to_date),
      final_status: getValue(params, `status`, ""),
    };
    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    let levelObj: any = {};
    //finding only levels params if it presented in URL
    for (let i = 1; i < 11; i++) {
      if (getValue(paramsObj, `level${i}`, "")) {
        levelObj[`level_${i}`] = getValue(paramsObj, `level${i}`, "").split(
          "_"
        )[0];
      }
    }
    setIsLoading(true);
    let queryRequest = QueryRequestHelper({ ...payload, ...levelObj });
    try {
      setIsLoading(true);
      // let resp = await getShowCauseNotices(queryRequest);
      let resp = await getShowCauseNoticesEntityMapping(queryRequest);
      let entityMapping = await getEntityGroups(queryRequest);
      if (entityMapping) {
        let arr1: any = [
          {
            Header: "Sl.No.",
            accessor: "index",
            width: 50,
            // Cell: ({ row }: any) => {
            //   return (
            //     // <NavLink to={`/configuration/vendors/detail/${row.original.id}`}>
            //     <>{row.values.id}</>
            //     // </NavLink>
            //   );
            // },
          },
        ];
        let arr2: any = [];
        let arr3: any = [
          {
            Header: "Notice Date",
            accessor: "notice_dated",
            width: 120,
          },
          {
            Header: "Received Date",
            accessor: "received_on",
            width: 120,
          },
          {
            Header: "Deadline Date",
            accessor: "notice_reply_deadline",
            width: 200,
          },
          {
            Header: "Notice Information",
            accessor: "show_cause_related_to",
            width: 300,
          },
          {
            Header: "Final Status",
            accessor: "final_status",
            width: 100,
          },
        ];
        getValue(entityMapping, `data.entityGroups`, []).map((item: any) => {
          return arr2.push({
            Header: getValue(item, `group_name`, ""),
            accessor: `level_${getValue(item, `group_level`, "")}_entity_name`,
            width: 120,
          });
        });
        if (getValue(arr2, `length`, 0) > 0) {
          let col = arr1.concat(arr2, arr3);
          setColumns(col);
        } else {
          let col = arr1.concat(arr3);
          setColumns(col);
        }
      }

      if (resp) {
        setIsLoading(false);
        setList(
          getValue(resp, `data.notices`, []).map(
            (item: object, index: number) => ({
              ...item,
              index: index + 1,
              notice_dated: getValue(item, `notice_dated`, "")
                ? convertCurrentDate(getValue(item, `notice_dated`, ""))
                : null,
              notice_reply_deadline: getValue(item, `notice_reply_deadline`, "")
                ? convertCurrentDate(
                    getValue(item, `notice_reply_deadline`, "")
                  )
                : null,
              received_on: getValue(item, `received_on`, "")
                ? convertCurrentDate(getValue(item, `received_on`, ""))
                : null,
              remainder_required_on: getValue(item, `remainder_required_on`, "")
                ? convertCurrentDate(
                    getValue(item, `remainder_required_on`, "")
                  )
                : null,
              created_date: getValue(item, `created_at`, "")
                ? convertCurrentDate(getValue(item, `created_at`, ""))
                : null,
              action_taken: getValue(item, `action_taken`, false)
                ? "Yes"
                : "No",
              reporting_person_name:
                getValue(item, `reporting_person.first_name`, "") +
                " " +
                getValue(item, `reporting_person.last_name`, ""),
              responsible_person_name:
                getValue(item, `responsible_person.first_name`, "") +
                " " +
                getValue(item, `responsible_person.last_name`, ""),
              level_1_entity_name: getValue(item, `level_1.entity_name`, ""),
              level_2_entity_name: getValue(item, `level_2.entity_name`, ""),
              level_3_entity_name: getValue(item, `level_3.entity_name`, ""),
              level_4_entity_name: getValue(item, `level_4.entity_name`, ""),
              level_5_entity_name: getValue(item, `level_5.entity_name`, ""),
              level_6_entity_name: getValue(item, `level_6.entity_name`, ""),
              level_7_entity_name: getValue(item, `level_7.entity_name`, ""),
              level_8_entity_name: getValue(item, `level_8.entity_name`, ""),
              level_9_entity_name: getValue(item, `level_9.entity_name`, ""),
              level_10_entity_name: getValue(item, `level_10.entity_name`, ""),
              final_status:
                formatText(getValue(item, `final_status`, ""))
            })
          )
        );
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Search section                               */
  /* -------------------------------------------------------------------------- */
  const [showSearchTextbox, setShowSearchTextbox] = useState(false);
  const [search_text, setSearchInput] = useState<any>("");

  const toggleSearch = () => {
    setShowSearchTextbox((prevState) => !prevState);
  };
  const toggleSearchClose = () => {
    setSearchInput("");
    toggleSearch();
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params.search_text) {
      delete params.search_text;
      let payload: any = { ...params };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
      getData(paramsObj);
    }
  };

  const handleChangeSearch = async (e: any) => {
    setSearchInput(e.target.value);
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      page_no: 1,
      search_text: e.target.value,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    if (!e.target.value) {
      getData(paramsObj);
    }
  };
  const [selectedIDs, setSelectedIDs] = useState<any>([]);
  const getTableState = (value: object) => {
    let selectedIndexList = Object.keys(
      getValue(value, `selectedRowIds`, {})
    ).map((item) => parseInt(item));
    let selectedIds =
      list.length > 0
        ? list.filter((_item: object, index: number) =>
            selectedIndexList.includes(index)
          )
        : [];
    if (selectedIds.length > 0) {
      setSelectedIDs(
        selectedIds.map((item: object) => getValue(item, `id`, ""))
      );
    } else {
      setSelectedIDs([]);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                                 Delete section                             */
  /* -------------------------------------------------------------------------- */

  const [deleteValue, setDeleteValue] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const handleDeleteFun = (id: string, value: string) => {
    setDeleteValue(value);
    setDeleteId(id);
    handleDelete();
  };
  const [isDelete, setIsDelete] = useState(false);
  const handleDelete = () => {
    setIsDelete(!isDelete);
  };

  const handleDeleteFunction = async () => {
    try {
      let resp = await adminDeleteSpecificOrganization(deleteId);
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        handleDelete();
        getData(paramsObj);
      }
    } catch (error) {}
  };

  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */

  const handleChangeSortBy = (value: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    params.sort_by = value;
    props.history.push({
      pathname: window.location.pathname,
      query: params,
    });
  };

  const handleChangeStatus = (name: string, value: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (value) {
      let payload = {
        ...params,
        [name]: value,
        page_no: 1,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    } else {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      delete params.status;
      let payload = {
        ...params,
        page_no: 1,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
      getData(paramsObj);
    }
  };
  /* -------------------------------------------------------------------------- */
  /*                               Pagination section                           */
  /* -------------------------------------------------------------------------- */

  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(100);
  const [page_no, setPage_no] = useState(1);

  const handleChangePagination = (page_no: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload = {
      ...params,
      page_no: page_no,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };
  const handleChangeLimit = (limit: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload = {
      ...params,
      limit: limit,
      page_no: 1,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };
  const handleEdit = (id: string) => {
    navigate(`/configuration/vendors/add/${id}`);
  };
  const rowClick = (obj: object) => {
    // console.log(getValue(obj,`original`,''))
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload = {
      ...params,
    };
    let queryRequest = QueryRequestHelper(payload);

    navigate(
      `/report/show-cause-notice/edit/${getValue(
        obj,
        `original.id`,
        ""
      )}?${mainQueryRequest}`
    );
  };
  const getTrProps = (rowInfo: any) => {
    if (getValue(rowInfo, `id`, "")) {
      return {
        style: {
          //   background:  'red',
          //   color: 'black'
        },
      };
    }
    return {};
  };
  const columnsOld = React.useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        width: 200,
        Cell: ({ row }: any) => {
          return (
            // <NavLink to={`/configuration/vendors/detail/${row.original.id}`}>
            <>{row.values.id}</>
            // </NavLink>
          );
        },
      },

      {
        Header: "Notice Date",
        accessor: "notice_dated",
        width: 200,
      },
      {
        Header: "Received Date",
        accessor: "received_on",
        width: 200,
      },
      {
        Header: "Deadline Date",
        accessor: "notice_reply_deadline",
        width: 200,
      },
      {
        Header: "Notice Imformation",
        accessor: "show_cause_related_to",
        width: 300,
      },
      // {
      //   Header: "Action Taken",
      //   accessor: "action_taken",
      //   width: 200,
      // },
      // {
      //   Header: "Responsible Person",
      //   accessor: "responsible_person_name",
      //   width: 200,
      // },
      // {
      //   Header: "Reporting Persion",
      //   accessor: "reporting_person_name",
      //   width: 200,
      // },
      // {
      //   Header: "Remainder Date",
      //   accessor: "remainder_required_on",
      //   width: 200,
      // },
      // {
      //   Header: "Created Date",
      //   accessor: "created_date",
      //   width: 200,
      // },
    ],
    []
  );

  const [columns, setColumns] = React.useState<any>([
    // {
    //   Header: "ID",
    //   accessor: "id",
    //   width: 200,
    //   Cell: ({ row }: any) => {
    //     return (
    //       // <NavLink to={`/configuration/vendors/detail/${row.original.id}`}>
    //       <>{row.values.id}</>
    //       // </NavLink>
    //     );
    //   },
    // },
    // {
    //   Header: "Notice Date",
    //   accessor: "notice_dated",
    //   width: 200,
    // },
    // {
    //   Header: "Received Date",
    //   accessor: "received_on",
    //   width: 200,
    // },
    // {
    //   Header: "Deadline Date",
    //   accessor: "notice_reply_deadline",
    //   width: 200,
    // },
    // {
    //   Header: "Notice Imformation",
    //   accessor: "show_cause_related_to",
    //   width: 300,
    // },
  ]);

  const handleChangeActiveStatus = async (value: string) => {
    try {
      let resp = await UpdateBulkStatusCheckpointPEComplianceTask({
        ids: selectedIDs,
        is_active: value === "active" ? true : false,
      });
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        setSelectedIDs([]);
        getData(paramsObj);
      } else {
        getData(paramsObj);
      }
    } catch (error) {}
  };

  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  const [check, setCheck] = useState(false);
  const handleRemoveNavItems = () => {
    setCheck(!check);
    setSelectedIDs([]);
  };
  const handleNavigate = (id: string) => {
    navigate(`/activities/task/compliance/list/${id}?page_no=1`);
  };

  /* -------------------------------------------------------------------------- */
  /*                              Date Routes                                   */
  /* -------------------------------------------------------------------------- */
  const [date, setDate] = useState<Date | null>(null);
  // const handleSubmitDate = () => {
  //   let dates = moment(date).format("YYYY-MM-DD");
  //   if (dates && dates !== "Invalid date") {
  //     let payload: any = {
  //       date: dates,
  //     };
  //     let queryRequest = QueryRequestHelper(payload);
  //     navigate(`${window.location.pathname}?${queryRequest}`);
  //   } else {
  //     toast.error("Please select date");
  //   }
  // };

  const [checkpointList, setCheckpointList] = useState([]);

  const getAllCheckpoint = async () => {
    let payload: any = {
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: 100,
      country_id: getValue(request, `country_id`, ""),
      state_id: getValue(request, `state_id`, ""),
      category_of_law_id: getValue(request, `category_of_law_id`, ""),
      legislation_id: getValue(request, `legislation_id`, ""),
      legislation_rule_id: getValue(request, `legislation_rule_id`, ""),
    };
    let queryRequest = QueryRequestHelper(payload);
    let resp = await adminGetCheckpoint(queryRequest);
    if (resp) {
      setCheckpointList(
        getValue(resp, `data.checkpoints`, []).map((item: object) => ({
          value: getValue(item, `checkpoint_id`, ""),
          label: getValue(item, `checkpoint_id`, ""),
          id: getValue(item, `id`, ""),
        }))
      );
    }
  };

  const getDropdownInfo = async () => {
    let payload: any = {
      page_no: 1,
      page_size: 100,
    };
    let queryRequest = QueryRequestHelper(payload);
    let frequency = await adminGetListManagementGroupCode("frequency");
    if (frequency) {
      let list =
        getValue(frequency, `data.listItems.length`, 0) > 0
          ? getValue(frequency, `data.listItems`, []).filter((item: object) =>
              getValue(item, `is_active`, "")
            )
          : [];
      setFrequencyList(
        list.map((item: object) => ({
          value: getValue(item, `text`, ""),
          label: getValue(item, `text`, ""),
          id: getValue(item, `id`, ""),
        }))
      );
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                                  Smart Filters                             */
  /* -------------------------------------------------------------------------- */

  const [request, setRequest] = useState<any>({
    country_id: "101",
    state_id: "",
    category_of_law_id: "",
    legislation_id: "",
    legislation_rule_id: "",
    frequency_id: "",
    location_id: "",
    function_id: "",
    checkpoint_id: "",
  });

  useEffect(() => {
    getAllCheckpoint();
  }, [
    request.country_id,
    request.state_id,
    request.category_of_law_id,
    request.legislation_id,
    request.legislation_rule_id,
  ]);

  useEffect(() => {
    getStatesList(request.country_id);
  }, [request.country_id]);

  const [countryList, setCountryList] = useState([]);
  const [states, setStates] = useState([]);
  const [frequencyList, setFrequencyList] = useState([]);

  const reset = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      page_no: params.page_no,
      search_text: getValue(params, `search_text`, ""),
      limit: getValue(params, `limit`, ""),
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    setFilterVisibility(!isFilterVisible);
    getData({});
    setParamsObj({});
  };
  const [resetInput, setResetInput] = useState(false);

  const getCountriesList = async () => {
    try {
      let resp = await adminGetCountriesListManagement();
      if (resp) {
        setCountryList(
          getValue(resp, `data.countries`, []).map((item: object) => ({
            ...item,
            value: getValue(item, `name`, ""),
            label: getValue(item, `name`, ""),
          }))
        );
      } else {
      }
    } catch (error) {}
  };

  const getStatesList = async (countryId: number) => {
    if (countryId) {
      try {
        let resp = await adminGetStatesListManagement(countryId);
        if (resp) {
          setStates(
            getValue(resp, `data.states`, []).map((item: object) => ({
              ...item,
              value: getValue(item, `name`, ""),
              label: getValue(item, `name`, ""),
            }))
          );
        } else {
        }
      } catch (error) {}
    }
  };

  /* ---------------------------  Category Of Law  ----------------------------- */
  const [categoryOfLawList, setCategoryOfLawList] = useState([]);
  const [categoryLawLoading, setCategoryLawLoading] = useState(false);
  const getCategoryLawList = async (
    value: string,
    state_id: string,
    id: string
  ) => {
    try {
      setResetInput(false);
      setCategoryLawLoading(true);
      let payload = {
        page_no: 1,
        page_size: 10,
        search_text: value,
        state_id: state_id ? state_id : getValue(request, `state_id`, ""),
        id: id,
      };
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getSmartFilterCategoryOfLawList(queryRequest);
      if (resp) {
        setCategoryOfLawList(
          getValue(resp, `data.stateCategoryOfLaw`, []).map((item: object) => ({
            // ...item,
            // id: getValue(item, `category_of_law.id`, ""),
            id: getValue(item, `id`, ""),
            value: getValue(item, `category_of_law.text`, ""),
            label: getValue(item, `category_of_law.text`, ""),
          }))
        );
        setCategoryLawLoading(false);
        setValue(request, `category_of_law_id`, "");
      } else {
        setCategoryLawLoading(false);
      }
    } catch (error) {
      setCategoryLawLoading(false);
    }
    if (!value) {
      setValue(request, `category_of_law_id`, "");
    }
  };

  /* ---------------------------  Legislation  ----------------------------- */
  const [legislationList, setLegislationList] = useState([]);
  const [legislationLoading, setLegislationLoading] = useState(false);
  const getLegislationList = async (
    value: string,
    state_id: string,
    id: string
  ) => {
    try {
      setResetInput(false);
      setLegislationLoading(true);
      let payload = {
        page_no: 1,
        page_size: 10,
        search_text: value,
        state_id: state_id ? state_id : getValue(request, `state_id`, ""),
        id: id,
      };
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getSmartFilterLegislationList(queryRequest);
      if (resp) {
        setLegislationList(
          getValue(resp, `data.legislations`, []).map((item: object) => ({
            ...item,
            value: getValue(item, `legislation_name`, ""),
            label: getValue(item, `legislation_name`, ""),
          }))
        );
        setLegislationLoading(false);
        setValue(request, `legislation_id`, "");
      } else {
        setLegislationLoading(false);
      }
    } catch (error) {
      setLegislationLoading(false);
    }
    if (!value) {
      setValue(request, `legislation_id`, "");
    }
  };

  /* ---------------------------  Legislation Rule  ----------------------------- */
  const [ruleList, setRuleList] = useState([]);
  const [legislationRuleLoading, setLegislationRuleLoading] = useState(false);
  const getLegislationRuleList = async (
    value: string,
    legislation_id: string,
    id: string
  ) => {
    try {
      setResetInput(false);
      setLegislationRuleLoading(true);
      let payload = {
        page_no: 1,
        page_size: 10,
        search_text: value,
        legislation_id: legislation_id
          ? legislation_id
          : getValue(request, `legislation_id`, ""),
        id: id,
      };
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getSmartFilterLegislationRuleList(queryRequest);
      if (resp) {
        setRuleList(
          getValue(resp, `data.legislationRules`, []).map((item: object) => ({
            ...item,
            value: getValue(item, `rule_name`, ""),
            label: getValue(item, `rule_name`, ""),
          }))
        );
        setLegislationRuleLoading(false);
        setValue(request, `legislation_rule_id`, "");
      } else {
        setLegislationRuleLoading(false);
      }
    } catch (error) {
      setLegislationRuleLoading(false);
    }
    if (!value) {
      setValue(request, `legislation_rule_id`, "");
    }
  };

  /* ---------------------------  Locations  ----------------------------- */
  const [locationLoading, setLocationLoading] = useState(false);
  const [locations, setLocations] = useState([]);

  const getLocationList = async (value: string, id: string) => {
    try {
      setResetInput(false);
      setLocationLoading(true);
      let payload: any = {
        page_no: 1,
        page_size: 10,
        search_text: value,
        id: id,
      };
      let queryRequest = QueryRequestHelper(payload);
      let locations = await clientGetLocation(queryRequest);
      if (locations) {
        setLocations(
          getValue(locations, `data.locations`, []).map((item: object) => ({
            value: getValue(item, `location_name`, ""),
            label: getValue(item, `location_name`, ""),
            id: getValue(item, `id`, ""),
          }))
        );
        setLocationLoading(false);
        setValue(request, `location_id`, "");
      } else {
        setLocationLoading(false);
      }
    } catch (error) {
      setLocationLoading(false);
    }
    if (!value) {
      setValue(request, `location_id`, "");
    }
  };

  /* ---------------------------  Functions  ----------------------------- */
  const [functionLoading, setFunctionLoading] = useState(false);
  const [functions, setFunctions] = useState([]);

  const getLocationFunctions = async (
    value: string,
    location_id: string,
    id: string
  ) => {
    let payload: any = {
      page_no: 1,
      page_size: 10,
      search_text: value,
      location_id: location_id,
      id: id,
    };
    let queryRequest = QueryRequestHelper(payload);
    try {
      setResetInput(false);
      setFunctionLoading(true);
      let resp = await clientGetFunction(queryRequest);
      if (resp) {
        setFunctions(
          getValue(resp, `data.functions`, []).map((item: object) => ({
            value: getValue(item, `function_name`, ""),
            label: getValue(item, `function_name`, ""),
            id: getValue(item, `id`, ""),
          }))
        );
        setFunctionLoading(false);
        setValue(request, `function_id`, "");
      } else {
        setFunctionLoading(false);
      }
    } catch (error) {
      setFunctionLoading(false);
    }
    if (!value) {
      setValue(request, `function_id`, "");
    }
  };

  /* ---------------------------  Onchange Smart filter  ----------------------------- */

  const handleChangeSelect = (e: any, type: string) => {
    if (type === "country_id") {
      getStatesList(e.id);
      setStates([]);
      setCategoryOfLawList([]);
      setLegislationList([]);
      setRuleList([]);
      setRequest({
        ...request,
        country_id: e.id,
        state_id: "",
        category_of_law_id: "",
        legislation_id: "",
        legislation_rule_id: "",
      });
    }
    if (type === "state_id") {
      setRequest({
        ...request,
        state_id: getValue(e, `id`, "") ? e.id : "",
        category_of_law_id: "",
        legislation_id: "",
        legislation_rule_id: "",
      });
      getCategoryLawList("", e.id, "");
      getLegislationList("", e.id, "");
      setCategoryOfLawList([]);
      setLegislationList([]);
      setRuleList([]);
    }
    if (type === "category_of_law_id") {
      setRequest({
        ...request,
        category_of_law_id: getValue(e, `id`, "") ? e.id : "",
      });
    }
    if (type === "legislation_id") {
      getLegislationRuleList("", getValue(e, `id`, "") ? e.id : "", "");
      setRequest({
        ...request,
        legislation_id: getValue(e, `id`, "") ? e.id : "",
        legislation_rule_id: "",
      });
    }
    if (type === "legislation_rule_id") {
      setRequest({
        ...request,
        legislation_rule_id: getValue(e, `id`, "") ? e.id : "",
      });
      getAllCheckpoint();
    }
    if (type === "frequency_id") {
      setRequest({
        ...request,
        frequency_id: getValue(e, `id`, "") ? e.id : "",
      });
    }
    if (type === "location_id") {
      setRequest({
        ...request,
        location_id: getValue(e, `id`, "") ? e.id : "",
      });
      getLocationFunctions("", getValue(e, `id`, "") ? e.id : "", "");
    }
    if (type === "function_id") {
      setRequest({
        ...request,
        function_id: getValue(e, `id`, "") ? e.id : "",
      });
    }
    if (type === "checkpoint_id") {
      setRequest({
        ...request,
        checkpoint_id: getValue(e, `id`, "") ? e.id : "",
      });
    }
  };

  /* ---------------------------  Submit Smart filter ----------------------------- */

  const handleSubmitSmartFilter = () => {
    let levelObj: any = {};
    //finding only levels params if it presented in URL
    for (let i = 1; i < 11; i++) {
      if (getValue(paramsObj, `level${i}`, "")) {
        levelObj[`level${i}`] = getValue(paramsObj, `level${i}`, "");
      }
    }
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
    };
    let queryRequest = QueryRequestHelper({ ...payload, ...levelObj });
    navigate(`${window.location.pathname}?${queryRequest}`);
    handleFilter();
  };
  /* ---------------------------  Entity Mapping Filters  ----------------------------- */

  const [headerList, setHeaderList] = useState([]);
  const [headerGroupList, setHeaderGroupList] = useState<any>([]);

  const [headerLoading, setHeaderLoading] = useState(true);
  const [levelObj, setLevelObj] = useState<any>({});
  const [paramsObj, setParamsObj] = useState<any>({});

  const getHeaderList = async (paramsObj: any, index: number) => {
    let userSpec = getValue(localStorage, `user`, {});
    let user: any = JSON.parse(userSpec);
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      status: params.status ? params.status : "",
      sort_by: params.sort_by,
      // user_id:getValue(user,`id`,'')
    };
    let queryRequest = QueryRequestHelper(payload);
    try {
      let resp = await getEntityGroups(queryRequest);
      // let resp = await getUserEntityGroups(queryRequest)
      if (resp) {
        setHeaderList(getValue(resp, `data.entityGroups`, []));
        let headers = [{ group_name: "Overall" }];
        let headerGroups = getValue(resp, `data.entityGroups`, []);
        setHeaderGroupList(headers.concat(headerGroups));
        var result: any = {};
        for (
          let i = 0;
          i < getValue(resp, `data.entityGroups.length`, 0);
          i++
        ) {
          result[
            `${getValue(resp, `data.entityGroups[${i}].group_level`, "")}`
          ] = { [getValue(resp, `data.entityGroups[${i}].id`, "")]: {} };
        }
        if (Object.keys(levelObj).length === 0) {
          for (let x in result) {
            let keys = Object.keys(result[x])[0];
            levelObj[keys] = {};
          }
        }
        // delete params[`checkpoint_id[]`];
        let list =
          Object.values(paramsObj).length > 0 ? Object.values(paramsObj) : [];

        if (getValue(list, `length`, 0) > 0) {
          getEntityList(
            1,
            getValue(resp, `data.entityGroups[${0}].id`, ""),
            null,
            ""
          );

          list.map((item: any, _index: number) => {
            let findNextLevelInfo = getValue(
              resp,
              `data.entityGroups`,
              []
            ).filter(
              (ite: any, i: number) =>
                ite.group_level - 1 === parseInt(item.split("_")[2])
            );
            // if (_index === index)
            return getEntityList(
              parseInt(item.split("_")[2]) + 1,
              getValue(findNextLevelInfo, `[${0}].id`, ""),
              item.split("_")[0],
              ""
            );
          });
        } else {
          getEntityList(
            1,
            getValue(resp, `data.entityGroups[${0}].id`, ""),
            null,
            ""
          );
        }
        setHeaderLoading(false);
      } else {
        setHeaderLoading(false);
      }
    } catch (error) {
      setHeaderLoading(false);
    }
  };

  const getEntityGroupsUponSelection = async (
    paramsObj: object,
    index: number,
    group_level: any,
    entity_id: any
  ) => {
    let list =
      Object.values(paramsObj).length > 0 ? Object.values(paramsObj) : [];
    if (getValue(list, `length`, 0) > 0) {
      list.map((item: any, _index: number) => {
        let findNextLevelInfo = headerList.filter(
          (ite: any) => ite.group_level === parseInt(item.split("_")[2]) + 1
        );
        if (_index === index)
          return getEntityList(
            group_level,
            getValue(findNextLevelInfo, `[${0}].id`, ""),
            entity_id,
            ""
          );
      });
    }
  };
  const [childEntityList, setChildEntityList] = useState<any>({});
  const [childEntityLoading, setChildEntityLoading] = useState(false);
  const getEntityList = async (
    group_level: any,
    group_id: string,
    entity_id: any,
    search_text: string
  ) => {
    let payload = {
      limit: 10,
      search_text: search_text,
      level: group_level,
      entity_parent: entity_id,
    };

    let queryRequest = QueryRequestHelper(payload);
    setChildEntityLoading(true);
    try {
      // let resp = await getChildEntityGroups(queryRequest);
      let resp = await getUserEntityGroupsItems(queryRequest);
      if (resp) {
        levelObj[group_id] = getValue(resp, `data.entityMapping`, []).map(
          (item: any) => ({
            ...item,
            value: getValue(item, `entity_name`, ""),
            label: getValue(item, `entity_name`, ""),
          })
        );
        setLevelObj({ ...levelObj });
        setChildEntityLoading(false);
      } else {
        setChildEntityLoading(false);
      }
    } catch (error) {
      setChildEntityLoading(false);
    }
  };

  const handleClickEntity = (
    entity_id: any,
    group_id: any,
    group_level: any,
    headerIndex: number
  ) => {
    //user selected level
    let userLevel = `${entity_id}_${group_id}_${group_level}`;
    let payload = { ...paramsObj };
    let selectedLevels =
      Object.values(payload).length > 0 ? Object.values(payload) : [];
    if (!selectedLevels.includes(userLevel)) {
      // appending child entity list that are presented in URL Params
      var result = Object.entries(childEntityList);
      var myNewArray: any =
        getValue(result, `length`, 0) > 0
          ? result.filter(function (item, index) {
              return index + 1 <= group_level;
            })
          : [];
      let obj: any = {};
      if (getValue(myNewArray, `length`, 0) > 0) {
        myNewArray.map((item: any) => {
          obj[item[0]] = item[1];
        });
      }
      setChildEntityList(obj);

      //deleting params if grater then current level selected by the user
      for (let i = group_level + 1; i < 10; i++) {
        delete paramsObj[`level${i}`];
      }

      // replacing url param if it have same group level / else we can add new one
      let checkIfAlreadyExist =
        Object.keys(payload).length > 0
          ? Object.keys(payload).includes(`level${group_level}`)
          : false;
      if (checkIfAlreadyExist) {
        delete paramsObj[`level${group_level}`];
        let obj = {
          ...paramsObj,
          [`level${group_level}`]: `${entity_id}_${group_id}_${group_level}`,
        };
        setParamsObj(obj);
        getEntityGroupsUponSelection(
          obj,
          headerIndex,
          parseInt(group_level) + 1,
          entity_id
        );
      } else {
        let obj = {
          ...paramsObj,
          [`level${group_level}`]: `${entity_id}_${group_id}_${group_level}`,
        };
        setParamsObj(obj);
        getEntityGroupsUponSelection(
          obj,
          headerIndex,
          parseInt(group_level) + 1,
          entity_id
        );
      }
    } else {
      // toast.error("Already selected");
    }
  };
  const handleChange = (
    val: string,
    group_id: string,
    group_level: any,
    index: number
  ) => {
    let entityID = getValue(paramsObj, `level${parseInt(group_level) - 1}`, "")
      ? getValue(paramsObj, `level${parseInt(group_level) - 1}`, "").split(
          "_"
        )[0]
      : null;

    if (!val) {
      getEntityList(group_level, group_id, entityID, "");
      let length = Object.keys(paramsObj).length;
      for (let i = group_level; i <= length; i++) {
        let id =
          paramsObj[`level${i + 1}`] &&
          paramsObj[`level${i + 1}`].split("_")[1];
        if (id) {
          levelObj[id] = {};
        }
        delete paramsObj[`level${i}`];
      }
      let obj = {
        ...paramsObj,
      };
      setParamsObj(obj);
      getHeaderList(obj, index);
    } else {
      getEntityList(group_level, group_id, entityID, val);
    }
  };
  /* -------------------------------------------------------------------------- */
  /*                             Download Reports                               */
  /* -------------------------------------------------------------------------- */
  const [downloadLoading, setDownloadLoading] = useState(false);
  const handleDownloadSelfComplianceReport = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let selectedIDs: any = urlSearchParams.getAll("smart_filter_tags[]");
    let dates = params.date ? new Date(params.date) : new Date();
    var from_date = params.from_date
      ? params.from_date
      : new Date(dates.getFullYear(), dates.getMonth(), 1);
    var to_date = params.to_date
      ? params.to_date
      : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);
    let payload: any = {
      from_date: convertDate(from_date),
      to_date: convertDate(to_date),
      // page_no: params.page_no ? parseInt(params.page_no) : 1,
      // page_size: params.limit ? parseInt(params.limit) : limit,
      // search_text: params.search_text,
      status: getValue(params,`status`,''),
      sort_by: params.sort_by,
    };
    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    let levelObj: any = {};
    //finding only levels params if it presented in URL
    for (let i = 1; i < 11; i++) {
      if (getValue(paramsObj, `level${i}`, "")) {
        levelObj[`level_${i}`] = getValue(paramsObj, `level${i}`, "").split(
          "_"
        )[0];
      }
    }
    let queryRequest = QueryRequestHelper({ ...payload, ...levelObj });
    setDownloadLoading(true);
    try {
      let resp = await exportShowCauseNotice(queryRequest);
      if (resp) {
        setDownloadLoading(false);
        toast.success(getValue(resp, `message`, ""));
        // navigate(`/self-compliance-logs/SELFCOMP_MY_TASKS`);
        handleDownloadOnClick(
          getValue(resp, `data.downloadUrl`, ""),
          "Show Cause Notice Report"
        );
      } else {
        setDownloadLoading(false);
      }
    } catch (error) {
      setDownloadLoading(false);
    }
  };
  const handleNavigateLogs = () => {
    navigate(`/self-compliance-logs/SELFCOMP_MY_TASKS`);
  };
  return (
    <DashboardLayout
      permissions={getValue(props, `tabPermissionList`, [])}
      subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
    >
      {!isLoading &&
      !getValue(props, `subTabPermissionList`, []).includes(
        "report_show_cause_notice"
      ) ? (
        <NoAccessPage />
      ) : (
        <>
          {getValue(selectedIDs, `length`, 0) > 0 && (
            <NavigationBar
              selectedIDs={selectedIDs}
              handleChangeActiveStatus={handleChangeActiveStatus}
              text={"MARK INACTIVE"}
              multi={
                getValue(props, `permissions`, []).includes("update")
                  ? true
                  : false
              }
              handleRemoveNavItems={handleRemoveNavItems}
            />
          )}
          {/* <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between">
            <div></div>
            <div className="filter-form-wrappper__container d-flex">
              <DatePicker
                selectsRange={true}
                startDate={from_date}
                endDate={to_date}
                className="react-date-picker__inputGroup__input"
                onChange={(update: any) => {
                  handleDate(update);
                }}
                dateFormat="d MMM yyyy"
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
              />
              <button
                className="dashboard-wrapper__apply-btn"
                onClick={handleSubmitDate}
              >
                Apply
              </button>
            </div>
          </div> */}

          <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <div className="header-parent-icon-holder">
                <MoreReportSvgComponent />
              </div>

              <div className="title-wrapper">
                <h6 className="dashbaord-wrapper__header-parent-title">
                  Reports
                </h6>
                <h4 className="dashbaord-wrapper__header-title">
                  Notices
                </h4>
              </div>
            </div>

            <div className="d-flex align-items-center">

              <RightMenuHeaders
                licenseStyleCalendar={true}
                dateRange={true}
                from_date={from_date}
                to_date={to_date}
                handleDate={handleDate}
                handleSubmitDate={handleSubmitDate}
                //search
                isSearch={true}
                searchInput={search_text}
                showSearchTextbox={showSearchTextbox}
                toggleSearch={toggleSearch}
                toggleSearchClose={toggleSearchClose}
                handleChangeSearch={handleChangeSearch}
                route={"/report/show-cause-notice/add"}
                add={
                  getValue(props, `permissions`, []).includes("create")
                    ? "true"
                    : "false"
                }
                //smartFilter
                smartFilter={true}
                handleFilter={handleFilter}
                // download section
                downloadSelfComplianceReport={true}
                handleDownloadSelfComplianceReport={
                  handleDownloadSelfComplianceReport
                }
                downloadLoading={downloadLoading}
                //logs section
                // viewDownloadedSelfComplianceReports={true}
                handleNavigateLogs={handleNavigateLogs}
                //Line Seperator of button
                lineSeperator={true}
                selectedFilterCount={countKeysWithValues(params)}
              />
            </div>
          </div>
          {isLoading || !props.permissionAPITriggered ? (
            <Loader />
          ) : (
            <div
              className={`main-page-layout-wrapper has-module-filter`}
              id={
                getValue(selectedIDs, `length`, 0) > 0
                  ? "blueNavigationVisible"
                  : ""
              }
            >
              <div className="admin-wrapper position-relative">
                <div className="admin-wrapper position-relative d-none">
                  <SearchHeader
                    route={"/report/show-cause-notice/add"}
                    searchInput={search_text}
                    showSearchTextbox={showSearchTextbox}
                    toggleSearch={toggleSearch}
                    toggleSearchClose={toggleSearchClose}
                    handleChangeSearch={handleChangeSearch}
                    isBulkUploadVisible={false}
                    smartFilter={true}
                    setFilterFormVisibility={() => {
                      setFilterVisibility(!isFilterVisible);
                    }}
                    isFilterVisible={isFilterVisible}
                    //download section
                    downloadSelfComplianceReport={true}
                    // viewDownloadedSelfComplianceReports={true}
                    handleDownloadSelfComplianceReport={
                      handleDownloadSelfComplianceReport
                    }
                    downloadLoading={downloadLoading}
                    handleNavigateLogs={handleNavigateLogs}
                    statusFilter
                    filterList={filterList}
                    handleChangeStatus={handleChangeStatus}
                    add={
                      getValue(props, `permissions`, []).includes("create")
                        ? true
                        : "false"
                    }
                  />
                </div>
                <div>
                  <ModuleFilter
                    statusFilter
                    filterList={filterList}
                    handleChangeStatus={handleChangeStatus}
                  />
                </div>
                {/* {isFilterVisible && ( */}
                <DashboardUserFilterForm
                  setFilterFormVisibility={() => {
                    setFilterVisibility(!isFilterVisible);
                  }}
                  reset={reset}
                  handleSubmitSmartFilter={handleSubmitSmartFilter}
                  //-----> Entity Mapping Filter
                  headerList={headerList}
                  headerLoading={headerLoading}
                  levelObj={levelObj}
                  childEntityLoading={childEntityLoading}
                  handleClickEntity={handleClickEntity}
                  urlParams={paramsObj}
                  handleChangeEntity={handleChange}
                  filterIsOpen={filterIsOpen}
                  handleFilter={handleFilter}
                />
                {/* )} */}
                {isLoading ? (
                  <Loader />
                ) : list.length > 0 ? (
                  <ScrollableReactTable
                    columns={columns}
                    data={list}
                    getTableState={getTableState}
                    rowClick={rowClick}
                    checkboxlogo={true}
                    selectedIDs={selectedIDs}
                    getTrProps={getTrProps}
                  />
                ) : (
                  <>
                    {Object.keys(params).length !== 0 ? (
                      <>
                        <ReportsNotfound
                          route={"/report/show-cause-notice/add"}
                        />
                      </>
                    ) : (
                      <ReportsNotfound
                        route={"/report/show-cause-notice/add"}
                      />
                    )}
                  </>
                )}
              </div>
              <div className="footer-wrapper d-flex justify-content-between">
                {list.length > 0 && (
                  <img
                    src="/images/building-illustration.svg"
                    className="img-fluid"
                  />
                )}
                {totalCount > 10 ? (
                  <PaginationPage
                    totalCount={totalCount}
                    limit={limit}
                    pageNumber={page_no}
                    handleChangePagination={handleChangePagination}
                    handleChangeLimit={handleChangeLimit}
                  />
                ) : (
                  <p className="show-rows-count mt-3 d-flex">
                    Total Count:&nbsp;&nbsp;{" "}
                    <p style={{ color: "rgb(13, 110, 253)" }}>{totalCount}</p>
                  </p>
                )}
              </div>
              <DeleteModal
                isOpen={isDelete}
                handleModal={handleDelete}
                handleSubmit={handleDeleteFunction}
                deleteValue={deleteValue}
              />
            </div>
          )}
        </>
      )}
    </DashboardLayout>
  );
};

export default ShowCauseNotice;
